import { Logger } from '../utilities/logger';
import { AbstractView } from './abstract-view';
import { Modal } from '../components/modal';
/**
 * A view displaying consent information in a modal window.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class ModalView extends AbstractView {
    constructor(api, container) {
        super(api, container);
        Logger.debug('modal-view', 'Starting to construct.');
        this.modal = new Modal(this.api, this.container);
        Logger.debug('modal-view', 'Finished constructing.');
    }
    show() {
        this.emitter.emit('show', this);
        Logger.info('modal-view', 'Show.');
        this.modal.show();
        this.emitter.emit('shown', this);
    }
    hide() {
        this.emitter.emit('hide', this);
        Logger.info('modal-view', 'Hide.');
        this.modal.hide();
        this.emitter.emit('hidden', this);
    }
}
